<template lang="pug">
  v-card.mt-5
    v-card-title
      div.statBox.round-corner.mt-n9
        chart(
          type="line",
          :options="options",
          :series="series",
        )
    v-divider
    v-card-text
      .body-1.bold {{ stats.name }}
      .body-2
        span {{ $t("charts.dashboard.month") }}
        br
        v-icon(small) fa fa-images
        span.ml-4.caption {{ current.analysis }}
        v-icon.ml-4(small) fa fa-user
        span.ml-4.caption {{ current.customer }}
</template>

<script>
import { formatDate } from '@/utils/helper';

import VueApexCharts from 'vue-apexcharts';

const getLabel = date => {
  const [month, year] = date.split(' ');

  return formatDate(new Date(year, parseInt(month) - 1, 1), 'MMM yyyy');
};

export default {
  components: {
    chart: VueApexCharts,
  },

  props: {
    labels: {
      type: Array,
      required: true,
    },

    stats: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      options: {
        stroke: {
          curve: 'smooth',
        },
        xaxis: {
          show: false,
          categories: [],
          labels: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
        chart: {
          height: 350,
          type: 'area',
          toolbar: {
            show: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        grid: {
          yaxis: {
            lines: {
              show: false,
            },
          },
        },
        yaxis: {
          labels: {
            style: {
              color: '#fff',
            },
          },
        },
        tooltip: {
          x: {
            show: false,
          },
          y: {
            show: false,
          },
        },
        theme: {
          mode: 'light',
        },
      },
      series: [],
      current: {},
    };
  },

  created() {
    this.options.chart.id = this.stats.name;
    this.options.xaxis.categories = this.labels;
    this.series[0] = {
      name: this.$t('charts.dashboard.customer'),
      data: this.stats.customer,
    };
    this.series[1] = {
      name: this.$t('charts.dashboard.analysis'),
      data: this.stats.analysis,
    };

    this.current = {
      customer: this.stats.customer[this.labels.length - 1],
      analysis: this.stats.analysis[this.labels.length - 1],
    };
  },
};
</script>

<style lang="scss">
.statBox {
  margin: 0 auto;
  max-width: calc(100% - 32px);
  position: relative;
  background: linear-gradient(60deg, #0054a6, #00acc1) !important;
}

.apexcharts-legend-text,
.apexcharts-yaxis-texts-g {
  color: white !important;
}
</style>
